var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.707 6.4812L10.3418 15.8984L7.5 13.0503L16.8793 3.63628C16.9714 3.54339 17.0809 3.46957 17.2016 3.41902C17.3222 3.36847 17.4516 3.34219 17.5825 3.34168C17.7133 3.34117 17.8429 3.36645 17.9639 3.41606C18.085 3.46567 18.1951 3.53864 18.2879 3.63081L18.2934 3.63628L19.707 5.05855C19.8947 5.24774 19.9999 5.50341 19.9999 5.76988C19.9999 6.03634 19.8947 6.29201 19.707 6.4812Z",
    fill: "#23BD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3387 15.902L8.20711 18.0453C8.02103 18.2328 7.7681 18.3387 7.50394 18.3398C7.23979 18.3408 6.98604 18.2368 6.79851 18.0508L6.79305 18.0453L0.293045 11.5078C0.105338 11.3187 0 11.0631 0 10.7967C0 10.5303 0.105338 10.2746 0.293045 10.0856L1.70711 8.66329C1.89288 8.47625 2.14524 8.37052 2.40886 8.36927C2.67248 8.36803 2.92583 8.47137 3.11336 8.65665L3.11961 8.66329L10.3387 15.902Z",
    fill: "#23BD86"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.839844)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.839844)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.bf106d0c.svg";
export { ForwardRef as ReactComponent };